/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019, 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { schema } from 'normalizr';

export const systemEntitySchema = new schema.Entity(
  'systemEntities',
  {},
  { idAttribute: 'entity' }
);

export const systemEntitiesSchema = new schema.Array(systemEntitySchema);
